var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.4,
    height: 97.11,
    viewBox: "0 0 137.4 97.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.07,108.86,39.26,57.52,36.1,61.4l62.81,51.34Zm59.65-51.34L98.91,108.86l3.16,3.88L164.89,61.4Zm-122.46,0A2.5,2.5,0,0,0,36.1,61.4Zm61.23,53.28-1.58,1.94a2.5,2.5,0,0,0,3.16,0Zm64.4-49.4a2.51,2.51,0,0,0-3.17-3.88Z",
    transform: "translate(-31.79 -53.61)",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.79,148.22V56.11h-5v92.11Zm129.9-2.5H34.29v5h132.4Zm-2.5-89.61v92.11h5V56.11Zm-129.9,2.5h132.4v-5H34.29Zm0,89.61h-2.5a2.5,2.5,0,0,0,2.5,2.5Zm132.4,0v2.5a2.5,2.5,0,0,0,2.5-2.5Zm0-92.11h2.5a2.5,2.5,0,0,0-2.5-2.5Zm-132.4,0v-2.5a2.5,2.5,0,0,0-2.5,2.5Z",
    transform: "translate(-31.79 -53.61)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconEmail);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-email.089392fe86ebd86125a366e6389cbf46.svg";
export { ForwardRef as ReactComponent };